<template>
  <div>TimelineRuler</div>
</template>

<script>
export default {
  name: "TimelineRuler"
};
</script>

